export const ReportType = {
    PRIVATE: "Private",
    PUBLIC: "Public",
} as const;

export type ReportType = (typeof ReportType)[keyof typeof ReportType];
